/**
 * Creates a promise based timer.
 *
 * @param {Number} time
 * @param  {...any} args
 */
export function timer(time, ...args) {
  return new Promise((resolve) => setTimeout(resolve, time, ...args));
}
